export default [
  {
    path: "/",
    meta: {
      title: "Dashboard",
      authRequired: true,
      permission: "dashboard.view",
    },
    name: "home",
    component: () => import("@/views/home.vue"),
  },
  {
    path: "/account/login",
    name: "login",
    component: () => import("@/views/account/login.vue"),
    meta: {
      title: "Login",
    },
  },
  {
    path: "/account/forgot-password",
    name: "forgot-password",
    component: () => import("@/views/account/forgot-password.vue"),
    meta: {
      title: "Forgot Password",
    },
  },
  {
    path: "/reset-password",
    name: "reset-password",
    component: () => import("@/views/account/reset-password.vue"),
    meta: {
      title: "Reset Password",
    },
  },
  {
    path: "/error/forbidden",
    name: "error-forbidden",
    component: () => import("@/views/error/forbidden.vue"),
    meta: {
      title: "Access Denied",
    },
  },
  {
    path: "/tickets",
    name: "tickets-list",
    component: () => import("@/views/tickets/list.vue"),
    meta: {
      title: "Tickets List",
      authRequired: true,
      permission: "ticket.view",
    },
  },
  {
    path: "/tickets/:id",
    name: "tickets-details",
    component: () => import("@/views/tickets/details.vue"),
    meta: {
      title: "Ticket Details",
      authRequired: true,
      permission: "ticket.view",
    },
  },
  {
    path: "/contacts/renters",
    name: "contacts-renters",
    component: () => import("@/views/contacts/renters.vue"),
    meta: {
      title: "Renters",
      authRequired: true,
      permission: "user.view",
    },
  },
  {
    path: "/contacts/hosts",
    name: "contacts-hosts",
    component: () => import("@/views/contacts/hosts.vue"),
    meta: {
      title: "Hosts",
      authRequired: true,
      permission: "user.view",
    },
  },
  {
    path: "/contacts/invites",
    name: "contacts-invites",
    component: () => import("@/views/contacts/invites.vue"),
    meta: {
      title: "Invites",
      authRequired: true,
      permission: "user.view",
    },
  },
  {
    path: "/contacts/background-checks",
    name: "contacts-background-checks",
    component: () => import("@/views/contacts/background-checks.vue"),
    meta: {
      title: "Background Checks",
      authRequired: true,
      permission: "background_check.view",
    },
  },
  {
    path: "/contacts/deleted",
    name: "contacts-deleted",
    component: () => import("@/views/contacts/deleted.vue"),
    meta: {
      title: "Deleted Users",
      authRequired: true,
      permission: "user.view",
    },
  },
  {
    path: "/contacts/users/:id/profile",
    name: "user-profile-settings",
    component: () => import("@/views/pages/profile/setting.vue"),
    meta: {
      title: "User Profile",
      authRequired: true,
      permission: "user.view",
    },
  },
  {
    path: "/contacts/renters/:id/profile",
    name: "renter-profile-settings",
    component: () => import("@/views/pages/profile/setting.vue"),
    meta: {
      title: "Renter Profile",
      authRequired: true,
      permission: "user.view",
    },
  },
  {
    path: "/insurance-policies",
    name: "insurance-policies",
    component: () => import("@/views/insurance-policies.vue"),
    meta: {
      title: "Insurance Policies",
      authRequired: true,
      permission: "insurance.view",
    },
  },
  {
    path: "/clients",
    name: "clients",
    component: () => import("@/views/clients.vue"),
    meta: {
      title: "Clients",
      authRequired: true,
      permission: "client.view",
    },
  },
  {
    path: "/bookings/properties",
    name: "bookings-properties",
    component: () => import("@/views/bookings/properties.vue"),
    meta: {
      title: "Properties",
      authRequired: true,
      permission: "property.view",
    },
  },
  {
    path: "/bookings/applications",
    name: "bookings-applications",
    component: () => import("@/views/bookings/applications.vue"),
    meta: {
      title: "Applications",
      authRequired: true,
      permission: "property.view",
    },
  },
  {
    path: "/bookings/agreements",
    name: "bookings-agreements",
    component: () => import("@/views/bookings/agreements.vue"),
    meta: {
      title: "Agreements",
      authRequired: true,
      permission: "property.view",
    },
  },
  {
    path: "/analytics-reports",
    name: "analytics-reports",
    component: () => import("@/views/analytics-reports.vue"),
    meta: {
      title: "Analytics and Reports",
      authRequired: true,
      permission: "analytics.view",
    },
  },
  {
    path: "/settings/admin-users",
    name: "settings-admin-users",
    component: () => import("@/views/settings/admin-users.vue"),
    meta: {
      title: "Admin Users",
      authRequired: true,
      permission: "admin.view",
    },
  },
  {
    path: "/settings/roles-permissions",
    name: "settings-roles-permissions",
    component: () => import("@/views/settings/roles-permissions.vue"),
    meta: {
      title: "Roles and Permissions",
      authRequired: true,
      permission: "role.view",
    },
  },
  {
    path: "/settings/security",
    name: "settings-security",
    component: () => import("@/views/settings/security.vue"),
    meta: {
      title: "Security Dashboard",
      authRequired: true,
      permission: "security.view",
    },
  },
  {
    path: "/admin/profile",
    name: "admin-profile-settings",
    component: () => import("@/views/pages/admin/profile-settings.vue"),
    meta: {
      title: "Profile Settings",
      authRequired: true,
    },
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      title: "Logout",
      authRequired: true,
    },
  },
];
